import React from 'react'
import {
  Snackbar as MuiSnackbar,
  SnackbarProps,
  Slide,
  SlideProps,
} from '@mui/material'

const SlideTransition = (props: SlideProps) => (
  <Slide {...props} direction='right' />
)

const Snackbar: React.FC<SnackbarProps> = ({ ...props }) => (
  <MuiSnackbar
    TransitionComponent={SlideTransition}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    {...props}
  />
)

export { Snackbar }

export type { SnackbarProps }
